export const PACKAGE_NAME = 'jivChildIssueTableHideDoneToggle';
export const TEAM_NAME = 'keystone';
